<template>
  <DialogTemplateToolkit
    v-if="tender.tenderStatus.id == statuseKeys.PREQUALIFICATION && !tender.biddingType.isFrameFirstStage"
    :dialog="dialog"
    first_btn="Tenders.Complete"
    :loading="loading"
    :title="$t('Tenders.CompleteWithoutAuction')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <MenuItem
        class="h11-links"
        data-qa="menu-complete-without-auction"
        icon="continue"
        :label="$t('Tenders.CompleteWithoutAuction')"
        @click="open"/>
    </template>
    <template #card-text>
      {{ $t('Tenders.TenderWithoutAuction') }}
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import { tenderMixin } from 'mixins'
const tender_api = new SmarttenderApi()

export default {
  name: 'completeWithoutAuction',
  mixins: [ tenderMixin] ,
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  props: {
    tender: Object
  },
  methods: {
    close() {
      this.dialog = false
    },
    open() {
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    apply() {
      this.loading = true
      tender_api.changeToAnalisisFromPrequalification(this.tender.tenderId).then( async () => {
        await this.$_updateStatus(this.tender)
        await this.$_updateTenderAccess(this.tender)
        this.dialog = true
      })
      // .then(() => this.$router.push({name: 'tenderitem', params: { id: this.tender.tenderId}}))
      this.loading = false
    }
  },
  components: {
    MenuItem,
    DialogTemplateToolkit
  }
}
</script>
